import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-multiple-choice-single-response',
  templateUrl: './preview-multiple-choice-single-response.component.html',
  styleUrls: ['./preview-multiple-choice-single-response.component.scss']
})
export class PreviewMultipleChoiceSingleResponseComponent {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
}
